/*
 * @Description:
 * @version:
 * @Author: 陈朋
 * @Date: 2021-11-16 15:44:31
 * @LastEditors: sueRim
 * @LastEditTime: 2021-11-16 16:00:23
 */

export const AccessManagementRouting = [
  {
    path: "/material/accessManagement/list",
    name: "basic-material-accessManagement-list",
    meta: { title: "出入库类型管理" },
    component: () =>
      import(
        /* webpackChunkName: "basic-accessManagement-brand" */ "@/views/material/access-management/list/index.vue"
      ),
  },
];
